import { render, staticRenderFns } from "./BaseSelected.vue?vue&type=template&id=d9158240&lang=true"
import script from "./BaseSelected.vue?vue&type=script&lang=js"
export * from "./BaseSelected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports